import { render, staticRenderFns } from "./GameScreen.vue?vue&type=template&id=6f854eb2&"
import script from "./GameScreen.vue?vue&type=script&lang=js&"
export * from "./GameScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports